import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=2678f5ce&scoped=true&"
import script from "./courseDetail.vue?vue&type=script&lang=js&"
export * from "./courseDetail.vue?vue&type=script&lang=js&"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=2678f5ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2678f5ce",
  null
  
)

export default component.exports